import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";

const useUserDetails = () => {
  const isLoggedIn = useAppSelector((state) => state.user.isLoggedIn);

  const user = useAppSelector((state) => state.user.currentUser);

  const userId = user?.id;

  const userGender = user?.gender;

  const hasRequiredPersonalInfo = !!user?.dob && !!userGender;

  const lastNameInitial = user?.lastName
    ? `${user?.lastName?.substring(0, 1).toLocaleUpperCase("en-US")}.`
    : "";

  const dashboardItemCards = user?.itemsOrder ?? [];

  const doesCardExists = (value: string) => {
    return dashboardItemCards.includes(value);
  };

  return {
    isLoggedIn,
    user,
    hasRequiredPersonalInfo,
    dashboardItemCards,
    lastNameInitial,
    userId,
    userGender,
    doesCardExists,
  };
};

export default useUserDetails;
